import React, { useState, useEffect } from 'react';
import './Lots.css';

import { PageTitle, ParkingInfo } from '../../../components';
import { apiPath } from '../../../constants';
import { callAPI } from '../../../constants';
import { FiMapPin } from "react-icons/fi";
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';

const Lots = () => { 

    const [location, setLocation] = useState({
        loaded: false,
        coordinates: { lat: "", lng: "" },
    });

    const [lotData, setLotData] = useState(null);
    const [lotKeys, setLotKeys] = useState([]);


    const [error, setError] = useState(null);

    const onSuccess = location => {

       // alert('lat:' + location.coords.latitude + "; lng:" + location.coords.longitude);
        
        setLocation({
            loaded: true,
            coordinates: {
                lat: location.coords.latitude,
                lng: location.coords.longitude,
            },
        });

        getLots(location.coords.latitude, location.coords.longitude);

    };

    const onError = error => {
        
        // 25.05772759864394, 121.61343556678405
        // setError(error.message);
        let lat = "25.05772759864394";
        let lng = "121.61343556678405";

        setLocation({
            loaded: true,
            coordinates: {
                lat: lat,
                lng: lng,
            },
        });

        getLots(location.lat, lng);


    };

    useEffect(() => {
        if (!navigator.geolocation) {

            // 表示沒有支援座標功能的瀏覽器
            setError('目前這個裝置不支援定位功能！');

        } else {

            console.log("目前支援用戶坐標");
            // 取得用戶目前的座標
            navigator.geolocation.getCurrentPosition(onSuccess, onError);
        }
    }, []);

    // const openMap = (latitude, longitude) => {
    //     const url = `https://www.google.com/maps?q=${latitude},${longitude}&hl=zh-CN`;
    //     window.open(url, '_blank');
    // };
    const openMap = (latitude, longitude) => {
        const geoUrl = `geo:${latitude},${longitude}?q=${latitude},${longitude}`;
        const mapsUrlIOS = `maps://maps.google.com/maps?daddr=${latitude},${longitude}&amp;ll=`;
        const webUrl = `https://maps.google.com/maps?daddr=${latitude},${longitude}&amp;ll=`;
    
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isAndroid = /Android/.test(navigator.userAgent);
    
        if (isIOS) {
            window.location.href = mapsUrlIOS;
        } else if (isAndroid) {
            window.location.href = geoUrl;
        } else {
            window.open(webUrl, '_blank');
        }
    };
    
    // 取得所有Lots的資料;
    const getLots = async (lat, lng) => {

        try {

            const url = apiPath.GET_URL_Lots;
            const header = null;
            const method = 'POST';
            let data = {
                lat: lat,
                lng: lng
            };
            const response = await callAPI({ method, url, header, data });
            const httpCode = response.status || -1;

            if(httpCode === 200) {

                let payload = null;

                // 檢查是否為JSON Object;
                if (typeof response.data === 'string') {
                    payload = JSON.parse(response.data);
                  } else {
                    payload = response.data;
                  }

                if( payload !== undefined) {
                    // 取得正確的資訊;  
                    console.log(payload);
                    let lotData = payload.data;
                    let lotKeys = Object.keys(lotData);

                    lotKeys.forEach((lotCode) => {

                        let lot = lotData[lotCode];
                        if(lot !== null) {
                            lot.fullAddress = lot.county + lot.district + lot.address;
                        }

                        lot.spaceKeys = Object.keys(lot.space);

                    });

                    setLotData(lotData);
                    setLotKeys(lotKeys);

                }

            }


        } catch(e) {

            alert(e.message);

        }
       



    };
 
  // const location = useLocation();  
  // const serviceSingle = location.state; 
  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />  
          
      {/* Page Title */}
      <PageTitle title={'停車場查詢'} page={'Lots'} />

      <section className='box-container'>
         {/* 單一停車場 */}
         <div className='lot-item' key="111">
            {/* Service Content Container */}
            <div className='content'>
            {/* Link to the individual service page */}
            <div className='member-profile-area'>
                {lotKeys.map(lotCode => (
                    <div key={lotCode} className='info-box'>
                    {/* <div className="parking-date">個人資料</div> */}
                    <div className="title" onClick={() => openMap(lotData[lotCode].lat, lotData[lotCode].lng)} >{lotData[lotCode].name}</div>
                    <div className="plateNo" onClick={() => openMap(lotData[lotCode].lat, lotData[lotCode].lng)} >{lotData[lotCode].distance} 公里 <FiMapPin /></div>
                    <div className="address">{lotData[lotCode].fullAddress}</div>
                    <div className="value"></div>
                    <div className="split"> </div>
                    {Object.keys(lotData[lotCode].space).map(spaceName => (
                        <div key={spaceName}>
                            <div className="label">{spaceName}</div>
                            <div className="value">{lotData[lotCode].space[spaceName].remain}</div>
                        </div>
                    ))}
                    <div className="split"> </div>
                    </div>
                ))} 
                
                
            </div>
            </div>
        </div>
      </section> 
    </> 
  );
}

export default Lots;
